module.exports = __webpack_public_path__ + "static/media/11.76784922.png";